<template>
  <v-container class="pa-0" fluid>
    <!-- <material-card icon="mdi-clipboard-text" inline :title="trainingTopicID ? 'Edit Training' : 'Add Training'"> -->
     <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="2" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  {{trainingTopicID ? 'Edit Training' : 'Add Training'}}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      <v-card-actions>
        <router-link slot="right" :to="{ name: 'teacherTrainingTopics' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" lg="6" md="6">
              <v-text-field hide-details class="my-0 py-1" label="Name" v-model.trim="formData.name" :rules="classRules" required></v-text-field>
            </v-col>
            <v-col cols="12" lg="6" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="formData.classID" :items="classData" item-text="name" item-value="id" label="Select Class Group" :rules="classRules" @input="getModuleData()"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6" md="6" v-if="getList.length > 0"><span id="abcd">Classes:</span><br>
              <v-chip-group column >
                <v-chip small color="accent"
                v-for='name in getList'
                :key="name"
                  >
                  {{ name }}
                </v-chip>
              </v-chip-group>
            </v-col>
<!-- <v-col cols="12" lg="6" v-if="getList.length > 0"><b>Classes</b> :<br> {{ getList }}</v-col> -->
            <v-col cols="12" lg="6" md="6">
              <v-autocomplete
                messages="Display modules with assessment only!"
                v-model="selectmodule"
                :items="moduleData"
                item-text="name"
                item-value="id"
                label="Select Modules"
                return-object
                @input="setSelectedData()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox hide-details class="my-0 py-1" v-model="formData.isActive" label="Is-Active"></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="selectedModules.length">
                <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
                  <v-text-field
                    :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                    v-model="search"
                    append-icon="mdi-magnify"
                    class="ml-auto mb-2"
                    label="Search"
                    hide-details
                    single-line
                    style="max-width:350px;"
                  ></v-text-field>
                </v-card-text>
                <v-divider class=" my-0 " />

                <v-data-table :headers="headers" @dragstart="dragstart" @drop="drop" @dragover="dragover" @dragleave="dragleave" :items="selectedModules" :search="search" :items-per-page="10">
                  <template v-slot:item.actions="{ item, index }">
                    <v-btn @click="deleteModule(null, item)" class="px-2 ml-1 white--text ma-1" color="error" min-width="0" small>
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
            </v-col>
            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-spacer />
                <v-btn color="primary" @click="onSubmit">
                  Save Training Topic
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
     </v-card>
    <!-- </material-card> -->
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
// import MaterialCard from '@/components/template/MaterialCard'
// import VCardComponent from '@/components/template/VCardComponent'
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)

export default {
  name: 'TeacherTrainingTopic',
  props: ['trainingTopicID'],
  // components: { VCardComponent },
  data () {
    return {
      tab: null,
      classData: [],
      search: '',
      moduleData: [],
      selectedModules: [],
      deletedExistingTrainingModule: [],
      selectmodule: null,
      getList: [],
      headers: [
        { text: 'Sequence', sortable: false, value: 'position' },
        { text: 'Name', sortable: false, value: 'moduleName' },
        { text: 'action', sortable: false, align: 'center', value: 'actions' }
      ],
      valid: false,
      classRules: [v => !!v || 'Item is required'],
      formData: {
        name: '',
        classID: '',
        isActive: false,
        trainingModuleMapsData: []
      },
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {},
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      await this.getClassData()
      if (this.trainingTopicID) {
        await this.getTrainingTopicData(this.trainingTopicID)
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    getTrainingTopicData: async function (trainingID) {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/teacher-training/training/get/${trainingID}`)
        this.isLoading = false
        this.formData.name = result.data.name
        this.formData.classID = result.data.studentClassGroup.id
        if (result.data.studentClassGroup.id) {
          await this.getModuleData()
          await this.getClassList(result.data.studentClassGroup.id)
        }
        this.formData.isActive = result.data.isActive
        if (!_.isEmpty(result.data.trainingModuleMaps)) {
          _.map(result.data.trainingModuleMaps, d => {
            d.moduleName = d.trainingModule.name
          })

          this.selectedModules = result.data.trainingModuleMaps
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassList: async function (classGroupID) {
      this.hasClicked = true
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/get-selected-classgroup-mapping/${classGroupID}`)
        this.mappingData = data
        let selectedClassObj = []
        if (this.mappingData) {
          const objectArray = Object.entries(this.mappingData)
          objectArray.forEach(([key, value]) => {
            value.studentClasses.map(function (k) {
              selectedClassObj.push(k.name)
            })
          })
          this.getList = selectedClassObj
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Class Group Mapping: ${errorMessage}`)
      }
    },
    deleteModule (delIndex, data) {
      this.$dialog.error({
        title: 'Delete Training ?',
        text: 'Do you want to Delete this Training?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              delIndex = this.selectedModules.map(x => x.id).indexOf(data.id)
              if (delIndex === this.selectedModules.length - 1) {
                if (data.id) {
                  data.deletedAt = moment().format('YYYY-MM-DD h:mm:ss')
                  this.deletedExistingTrainingModule.push(data)
                }
                this.selectedModules.splice(delIndex, 1)
              } else {
                if (data.id) {
                  data.deletedAt = moment().format('YYYY-MM-DD h:mm:ss')
                  this.deletedExistingTrainingModule.push(data)
                }
                this.selectedModules.splice(delIndex, 1)
                _.map(this.selectedModules, (d, index) => {
                  if (index >= delIndex) {
                    d.position = d.position - 1
                  }
                })
              }
              this.okMsg(' Training Deleted successfully!')
            }
          }
        }
      })
    },
    dragstart (payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover (payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index
      this.updateRecords(this.draggingRowIndex + 1, droppedOnRowIndex + 1, this.draggingRow)
    },
    updateRecords (from, to, data) {
      if (from === to) {
        return
      }
      if (from < to) {
        this.selectedModules[from - 1].position = to
        for (let i = from; i < to; i++) {
          this.selectedModules[i].position -= 1
        }
      }
      if (from > to) {
        this.selectedModules[from - 1].position = to
        for (let i = from - 2; i >= to - 1; i--) {
          this.selectedModules[i].position += 1
        }
      }
      this.selectedModules = _.sortBy(this.selectedModules, 'position')
    },
    setSelectedData (data) {
      if (this.selectedModules) {
        let trainingMIDs = _.map(this.selectedModules, 'trainingModuleID')
        if (!trainingMIDs.includes(this.selectmodule.id)) {
          this.selectedModules.push({
            trainingModuleID: this.selectmodule.id,
            position: this.selectedModules.length + 1,
            moduleName: this.selectmodule.name
          })
        } else {
          let message = `${this.selectmodule.name} is already in list`
          this.$buefy.dialog.alert({
            message: message,
            type: 'is-danger'
          })
        }
        this.selectmodule = null
      }
    },
    getModuleData: async function () {
      try {
        _.map(this.selectedModules, d => {
          if (d.id) {
            d.deletedAt = moment().format('YYYY-MM-DD h:mm:ss')
            this.deletedExistingTrainingModule.push(d)
          }
        })
        this.selectedModules = []
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/teacher-training/module/with-assessment?classID=${this.formData.classID}`)
        this.isLoading = false
        this.moduleData = data
        await this.getClassList(this.formData.classID)
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/student/getclass-group`)
        this.isLoading = false
        data = _.filter(data, e => {
          return e.type === constants.ClassGroupTypes.teacherTraining && e.isActive === true
        })
        this.classData = data
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onSubmit: async function () {
      try {
        this.formData.name = this.formData.name.trim()
        if (!this.valid) {
          return this.errMsg('Fill all form details')
        }
        if (_.isEmpty(this.selectedModules)) {
          return this.errMsg('Modules can not be empty')
        }
        let transection
        let message = null
        if (!this.trainingTopicID) {
          this.formData.trainingModuleMapsData = []
          this.formData.trainingModuleMapsData = this.selectedModules
          _.map(this.formData.trainingModuleMapsData, object => _.omit(object, ['moduleName']))
          transection = http.post(`${constants.API_URL}/api/teacher-training/training/create`, this.formData)
          message = 'Training topic added successfully!'
        } else {
          this.formData.id = this.trainingTopicID
          this.formData.trainingModuleMaps = []
          this.formData.trainingModuleMapsData = []
          _.map(this.selectedModules, d => {
            if (d.id) {
              this.formData.trainingModuleMaps.push(d)
            } else {
              this.formData.trainingModuleMapsData.push(d)
            }
          })
          if (!_.isEmpty(this.deletedExistingTrainingModule)) {
            _.map(this.deletedExistingTrainingModule, d => {
              if (d.id) {
                d.deletedAt = moment().format()
                this.formData.trainingModuleMaps.push(d)
              }
              // this.formData.trainingModuleMaps.push(d)
            })
          }

          this.formData.trainingModuleMaps = _.map(this.formData.trainingModuleMaps, object => _.omit(object, ['moduleName']))
          this.formData.trainingModuleMapsData = _.map(this.formData.trainingModuleMapsData, object => _.omit(object, ['moduleName']))
          transection = http.post(`${constants.API_URL}/api/teacher-training/training/update`, this.formData)
          message = 'Training topic updated successfully!'
        }

        if (transection) {
          this.isLoading = true
          await transection
          this.isLoading = false
          this.$buefy.dialog.alert({
            message: message,
            type: 'is-success'
          })
          this.$router.push({ name: 'teacherTrainingTopics' })
        } else {
          return
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped>
#abcd{
  color:rgba(0,0,0,.6) ;
  font-size: 16px;
}
</style>
